import App from "./App";
import ReactDOM from "react-dom/client";
import "@tremor/react/dist/esm/tremor.css";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
